"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ReportDialog = ReportDialog;
var _DialogTitle2 = _interopRequireDefault(require("@mui/material/DialogTitle"));
var _Dialog2 = _interopRequireDefault(require("@mui/material/Dialog"));
var _DialogActions2 = _interopRequireDefault(require("@mui/material/DialogActions"));
var _DialogContent2 = _interopRequireDefault(require("@mui/material/DialogContent"));
var _Typography2 = _interopRequireDefault(require("@mui/material/Typography"));
var _Tooltip2 = _interopRequireDefault(require("@mui/material/Tooltip"));
var _IconButton2 = _interopRequireDefault(require("@mui/material/IconButton"));
var _Close2 = _interopRequireDefault(require("@mui/icons-material/Close"));
var _react = _interopRequireDefault(require("react"));
var _reactI18next = require("react-i18next");
var _styledComponents = require("styled-components");
var _models = require("../models");
var _reportPopup = require("./map/report-popup");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function ReportDialog({
  currentUser,
  reportSourcesMap,
  report,
  onRating,
  ...props
}) {
  const titleKey = report && _models.reportTypesTitleKeys[report.typeCode];
  const source = report && report.sourceId !== null && reportSourcesMap?.[report.sourceId] || null;
  return /*#__PURE__*/_react.default.createElement(_Dialog2.default, _extends({
    fullWidth: true,
    maxWidth: "md"
  }, props), /*#__PURE__*/_react.default.createElement(StyledDialogTitle, null, /*#__PURE__*/_react.default.createElement(_reactI18next.Trans, {
    i18nKey: titleKey || 'commons.report.default_title'
  }), /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, "\xA0#", report?.id)), /*#__PURE__*/_react.default.createElement(CloseButtonWrapper, null, /*#__PURE__*/_react.default.createElement(_Tooltip2.default, {
    placement: "left",
    title: /*#__PURE__*/_react.default.createElement(_reactI18next.Trans, {
      i18nKey: "commons.actions.close"
    })
  }, /*#__PURE__*/_react.default.createElement(_IconButton2.default, {
    onClick: () => props.onClose(),
    size: "small"
  }, /*#__PURE__*/_react.default.createElement(_Close2.default, null)))), report?.photos[0] && /*#__PURE__*/_react.default.createElement("img", {
    src: report.photos[0].url
  }), /*#__PURE__*/_react.default.createElement(_DialogContent2.default, null, source && /*#__PURE__*/_react.default.createElement(_Typography2.default, {
    color: "textSecondary",
    component: "p",
    variant: "caption"
  }, /*#__PURE__*/_react.default.createElement(_reactI18next.Trans, {
    i18nKey: "commons.report.source",
    values: {
      source: source.title
    }
  })), report && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_Typography2.default, {
    gutterBottom: true,
    color: "textSecondary",
    component: "p",
    variant: "caption"
  }, /*#__PURE__*/_react.default.createElement(_reportPopup.ReportDate, {
    report: report,
    source: source
  })), report.description && /*#__PURE__*/_react.default.createElement(_Typography2.default, {
    variant: "body2"
  }, report.description))), report && /*#__PURE__*/_react.default.createElement(_DialogActions2.default, null, onRating && /*#__PURE__*/_react.default.createElement(_reportPopup.ReportReviews, {
    currentUser: currentUser,
    onRating: onRating,
    report: report
  })));
}
const StyledDialogTitle = (0, _styledComponents.styled)(_DialogTitle2.default)`
  && {
    padding-right: 46px;
  }
`;
const CloseButtonWrapper = _styledComponents.styled.div`
  position: absolute;
  right: 8px;
  top: 8px;

  button {
    background-color: rgba(255, 255, 255, 0.8);
  }
`;